import { bindable } from 'aurelia-framework';

export class WordItem {
    @bindable word;

    bind() {
        this.translation = this.word.translationString;
    }
}
